import { Component } from '@angular/core';
import { ReportsService } from '../../../Services/reports.service';
import { Subject, takeUntil } from 'rxjs';
import { UserType } from '../../../Shared/Enums/UserType';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import { itemsVM } from '../../../Model/items/itemsVM';
import { ItemsService } from '../../../Services/items.service';
import { LoginVm } from '../../../Model/LoginVM';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { ViewItemComponent } from '../../items/view-item/view-item.component';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { ShowImageComponent } from '../../../Shared/Components/show-image/show-image.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-items-data',
  templateUrl: './items-data.component.html',
  styleUrl: './items-data.component.scss'
})
export class ItemsDataComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  AllItems: itemsVM[] = [];
  currentUser: LoginVm = {};
  showEdit: boolean = false;
  imgPath: string = environment.ImgUrl;

  constructor(private apiReport: ReportsService, private apiItems: ItemsService, private auth: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private shared: SharedService, private dialogService: DialogService, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.GetAllItems();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }


  GetAllItems() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.apiItems.GetAllItems()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          this.AllItems = res.payload;
          this.spinner.hide();
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  EditItem(itemId?: number) {
    this.router.navigateByUrl('dashboard/edit-item/' + itemId);
  }

  ViewItem(itemId?: number) {
    const data = { 'selectedId': itemId };
    this.dialogService.openDialog(ViewItemComponent, data);
  }

  DeleteItem(itemId?: number) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoDeleteThis',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.spinner.show();
        this.ConfirmDeleteItem(itemId);
      }
    });
  }

  ConfirmDeleteItem(itemId?: number) {
    this.apiItems.DeleteItem(itemId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          this.toastrService.showSuccessToast('Success', "DeletedSuccessfully");
          this.GetAllItems();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }

  ShowImage(item?: any) {
    const data = { 'title': item.productName, 'pathImage': this.imgPath + "/" + item.ImgUrl };
    this.dialogService.openDialog(ShowImageComponent, data);
  }

  DownLoadItemsExcelReport() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.apiReport.DownLoadItemsExcelReport()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.spinner.hide();
          this.shared.downloadBlobExcelFile(data, 'ItemsData');
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  DownLoadItemsPDFReport() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.apiReport.DownLoadItemsPDFReport()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.spinner.hide();
          this.shared.downloadBlobFile(data, 'ItemsData');
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
